import { Component, inject, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideEllipsisVertical, lucideEye, lucidePen, lucideTrash } from '@ng-icons/lucide';
import { ChipComponent } from '@shared/components/chip/chip.component';
import { SidepanelService } from '@shared/components/sidepanel/sidepanel.service';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { HlmIconImports } from '@spartan-ng/helm/icon';

import { Site } from '../../../administration/gestion-sites/model/site.model';
import { Cartographie } from '../../../cartographie/models/cartographie.model';
import { CardEtapeComponent } from '../../../catalogue-national/card-etape/card-etape.component';
import { Étape } from '../../../référentiel-métier-parcours/models/étape.model';
import { ButtonClosePanelComponent } from '../../../shared/components/sidepanel/button-close-panel/button-close-panel.component';
import { ConvertEtatGroupeToStringPipe } from '../../pipes/convert-etat-groupe-to-string.pipe';
import { GetEtatEtapeVariantPipe } from '../../pipes/get-etat-etape-variant.pipe';
import { GetEtatEtapePipe } from '../../pipes/get-etat-etape.pipe';
import { FormGroupesComponent } from '../form-groupes/form-groupes.component';
import { ListGroupesComponent } from '../list-groupes/list-groupes.component';

@Component({
  selector: 'app-etape-item',
  imports: [
    HlmDropdownMenuImports,
    HlmButtonImports,
    HlmIconImports,
    CardEtapeComponent,
    GetEtatEtapePipe,
    ChipComponent,
    GetEtatEtapeVariantPipe,
    ConvertEtatGroupeToStringPipe,
  ],
  templateUrl: './etape-item.component.html',
  providers: [provideIcons({ lucidePen, lucideTrash, lucideEye, lucideEllipsisVertical })],
})
export class EtapeItemComponent {
  readonly #sidepanelService = inject(SidepanelService);

  readonly cartographie = input.required<Cartographie>();
  readonly site = input.required<Site>();
  readonly etape = input.required<Étape>();

  voirGroupes() {
    const étape = this.etape();

    this.#sidepanelService.setComponentToDisplay(
      'Voir les groupes',
      ListGroupesComponent,
      `Vous êtes en train de regarder les groupes de la formation <b>${étape.nom}</b>.`,
      { etape: étape, cartographie: this.cartographie() },
      ButtonClosePanelComponent,
    );
    this.#sidepanelService.open();
  }

  editerGroupes() {
    const étape = this.etape();
    const site = this.site();

    this.#sidepanelService.setComponentToDisplay(
      'Éditer les groupes',
      FormGroupesComponent,
      `Vous êtes en train d'éditer les groupes de la formation <b>${étape.nom}</b>. Veuillez renseigner les informations des différents groupes.`,
      { idSite: site.id, etape: étape, cartographie: this.cartographie() },
    );
    this.#sidepanelService.open();
  }

  retirerEtape() {
    const étape = this.etape();
    const site = this.site();
  }
}
